'use client';

import { useEffect } from 'react';
import { env } from '@hen-site/env';
import { newrelic } from '@hen-site/lib/newrelic/client';
import { logger } from '@hen-site/lib/logger/client';

/**
 * Set the app version and cohesion session ID and anonymous ID as custom attributes in New Relic.
 * @returns null
 */
export const ClientReady = () => {
  useEffect(() => {
    let retryCount = 0;
    const maxRetries = 50; // 50 * 100ms = 5 seconds max wait time

    // Wait for New Relic to be available before setting attributes
    const checkNewRelic = () => {
      if (typeof window !== 'undefined' && window.newrelic) {
        logger.info('ClientReady - New Relic available');
        newrelic.setCustomAttribute('appVersion', env.appVersion);

        if (window.cohesion) {
          window.cohesion('ready', () => {
            const { sessionId, anonymousId } =
              window.tagular?.('getAliasSet') ?? {};
            newrelic.setCustomAttribute('cohesionSessionId', sessionId);
            newrelic.setCustomAttribute('cohesionAnonymousId', anonymousId);
          });
        }
      } else if (retryCount < maxRetries) {
        // Retry after 100ms if NR not yet available and we haven't exceeded max retries
        retryCount++;
        setTimeout(checkNewRelic, 100);
      } else {
        logger.warn(
          'ClientReady - New Relic not available after 5 seconds, giving up',
        );
      }
    };

    checkNewRelic();
  }, []);
  return null;
};
